export default __webpack_public_path__ + "static/media/icon-upload-success.5dd5e754.svg";